import { render, staticRenderFns } from "./QuickActionsBar.vue?vue&type=template&id=6d6c4066&scoped=true"
import script from "./QuickActionsBar.vue?vue&type=script&lang=ts"
export * from "./QuickActionsBar.vue?vue&type=script&lang=ts"
import style0 from "./QuickActionsBar.vue?vue&type=style&index=0&id=6d6c4066&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6c4066",
  null
  
)

export default component.exports